const toAbsoluteUrl = (url, baseUrl) => {
  if (!url) return "";
  const origin = baseUrl
    || (typeof window !== "undefined" ? window.location.origin : "");
  if (/^https?:\/\//i.test(String(url))) {
    return String(url);
  }
  return `${origin}${String(url).startsWith("/") ? "" : "/"}${url}`;
};

export const buildKycVerifyUrl = ({ token, email, url, baseUrl } = {}) => {
  if (url) return toAbsoluteUrl(url, baseUrl);
  if (token) {
    const base = toAbsoluteUrl(`/complete-application/${token}`, baseUrl);
    // Carry the owner's own email so the verification page can prefill it.
    // It's the recipient's address (not third-party data), so this stays neutral.
    return email ? `${base}?email=${encodeURIComponent(email)}` : base;
  }
  return "";
};

// Broker owner links use the neutral complete-application route. The email is
// prefilled from the link; the existing UBO KYC login resolves the application.
export const resolveKycSubjectUrl = (subject = {}) => (
  buildKycVerifyUrl({
    url: subject.url,
    token: subject.token,
    email: subject.subjectEmail || subject.email,
  })
);

export default buildKycVerifyUrl;
